module.exports = __webpack_public_path__ + "img/bandeau_lamotte.0c554ffa.jpg";